import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, CanActivateChild } from '@angular/router';
import { NbAuthService ,NbAuthJWTToken} from '@nebular/auth';
import { tap, merge, map } from 'rxjs/operators';
import { NbAccessChecker } from '@nebular/security';
import { Observable, combineLatest } from 'rxjs';


@Injectable()
export class AuthGuard implements CanActivate, CanActivateChild {


  authService: NbAuthService;
  accessChecker: NbAccessChecker;
  constructor(private router: Router, authService: NbAuthService, accessChecker: NbAccessChecker) {
    this.authService = authService;
    this.accessChecker = accessChecker;
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
   
    this.authService.getToken().subscribe((token: NbAuthJWTToken) => {
      if (token.isValid()) {
      }
    });
    //console.log(3333333, state.url)
    var url = state.url;
    Object.keys(route.params).map(k => {
      if (route.params[k].trim() == '' || route.params[k] == undefined) {

      } else {
        url = url.replace(`/${route.params[k]}`, '');
      }
    });

    if (url != null && url.length > 0 && url.charAt(url.length - 1) == '/') {
      url = url.substring(0, url.length - 1);
    }
    //console.log(1111112222, url)
    return combineLatest(this.authService.isAuthenticated(), this.accessChecker.isGranted('access', `${url}`))
      .pipe(
        map(([auth, access]) => {
          // combineLatest returns an array of values, here we map those values to an object
          if (!auth) {
            this.router.navigate(['/auth/login']);
          }
          return auth && access
       // return true;
        })
      );
      //return this.authService.isAuthenticated()
      //  .pipe(
      //    tap(authenticated => {
      //      if (!authenticated) {
      //        this.router.navigate(['/auth/login']);
      //      }
      //    }),
      //);
  }

  canActivateChild(childRoute: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    //console.log(`canActivateChild`, childRoute, state.root.params)
    return true;
  }
}
